(function () {
  var body = document.body;
  var themeI18n = parseJsonScript(document.querySelector("[data-theme-i18n]")) || {};

  function i18n(key, fallback) {
    if (themeI18n && Object.prototype.hasOwnProperty.call(themeI18n, key) && themeI18n[key] !== "") {
      return themeI18n[key];
    }
    return fallback;
  }

  function parseJsonScript(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || "{}");
    } catch (error) {
      return null;
    }
  }

  function sanitizeQty(value) {
    var parsed = parseInt(value, 10);
    if (!Number.isFinite(parsed) || parsed < 1) return 1;
    return Math.min(parsed, 99);
  }

  function buildNavigationUrl(url) {
    if (!url) return url;
    try {
      var nextUrl = new URL(url, window.location.href);
      if (nextUrl.protocol !== "http:" && nextUrl.protocol !== "https:") {
        return url;
      }

      var currentUrl = new URL(window.location.href);
      var allowedNavigationParams = {
        "_fd": true,
        "pb": true,
        "preview_theme_id": true,
        "theme_id": true,
        "theme-editor-storefront-renderer-session-id": true,
        "theme_editor_session_token": true
      };
      var blockedNavigationParams = {
        "section": true,
        "block": true
      };

      currentUrl.searchParams.forEach(function (value, key) {
        var lowerKey = key.toLowerCase();
        var shouldKeep =
          Boolean(allowedNavigationParams[lowerKey]) ||
          lowerKey.indexOf("theme-editor-") === 0 ||
          lowerKey.indexOf("preview_") === 0 ||
          lowerKey.indexOf("preview-") === 0;

        if (blockedNavigationParams[lowerKey]) {
          shouldKeep = false;
        }

        if (shouldKeep && !nextUrl.searchParams.has(key)) {
          nextUrl.searchParams.set(key, value);
        }
      });

      return nextUrl.toString();
    } catch (error) {
      return url;
    }
  }

  function escapeTopNavigation(url) {
    if (!url) return;
    var nextHref = buildNavigationUrl(url);
    try {
      var isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
      if (isDesignMode && window.top && window.top !== window) {
        window.location.href = nextHref;
        return;
      }
    } catch (error) {
      /* no-op */
    }
    window.location.href = nextHref;
  }

  function redirectLegacyCollectionFilters() {
    try {
      var url = new URL(window.location.href);
      if (url.pathname.replace(/\/+$/, "") !== "/collections/all") return;

      var productType = (url.searchParams.get("filter.p.product_type") || "").trim().toLowerCase();
      if (!productType) return;

      var nextUrl = new URL(window.location.href);
      if (productType === "euc") {
        nextUrl.pathname = "/collections/types";
        nextUrl.searchParams.delete("filter.p.product_type");
        nextUrl.searchParams.set("q", "EUC");
      } else if (productType === "parts") {
        nextUrl.pathname = "/collections/types";
        nextUrl.searchParams.delete("filter.p.product_type");
        nextUrl.searchParams.set("q", "Parts");
      } else if (productType === "motorcycle") {
        nextUrl.pathname = "/collections/types";
        nextUrl.searchParams.delete("filter.p.product_type");
        nextUrl.searchParams.set("q", "Motorcycle");
      } else {
        return;
      }

      window.location.replace(nextUrl.toString());
    } catch (error) {
      /* no-op */
    }
  }

  function bindTopNavigation() {
    document.addEventListener("click", function (event) {
      var link = event.target.closest("[data-open-top]");
      if (!link) return;
      event.preventDefault();
      var drawer = document.querySelector("[data-drawer]");
      var drawerToggle = document.querySelector("[data-drawer-toggle]");
      if (drawer) {
        drawer.classList.remove("is-open");
        drawer.setAttribute("aria-hidden", "true");
      }
      if (drawerToggle) {
        drawerToggle.setAttribute("aria-expanded", "false");
      }
      body.style.overflow = "";
      try {
        var nextUrl = new URL(link.href, window.location.href);
        var currentUrl = new URL(window.location.href);
        var isSameDocument =
          nextUrl.origin === currentUrl.origin &&
          nextUrl.pathname === currentUrl.pathname &&
          nextUrl.hash;

        if (isSameDocument) {
          var target = document.querySelector(nextUrl.hash);
          if (target) {
            var header = document.querySelector("[data-site-header]");
            var headerOffset = header ? header.offsetHeight + 12 : 12;
            var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
            history.replaceState({}, "", nextUrl.hash);
            window.scrollTo({ top: Math.max(top, 0), behavior: "smooth" });
            return;
          }
        }
      } catch (error) {
        /* no-op */
      }
      escapeTopNavigation(link.href);
    });

    document.addEventListener("submit", function (event) {
      var form = event.target.closest("[data-open-top-form]");
      if (!form) return;
      event.preventDefault();
      var formData = new FormData(form);
      var query = new URLSearchParams(formData);
      var action = form.getAttribute("action") || "/search";
      escapeTopNavigation(action + "?" + query.toString());
    });
  }

  function bindLocalizationForms() {
    document.addEventListener("submit", function (event) {
      var form = event.target.closest(".language-switch-form, .market-switch-form");
      if (!form) return;

      var returnInput = form.querySelector('input[name="return_to"]');
      if (!returnInput) return;

      returnInput.value = window.location.pathname + window.location.search + window.location.hash;
    });
  }

  function formatCents(cents, currencyCode) {
    var amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currencyCode || "USD",
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2);
    }
  }

  function stripMoneyDecimals(value) {
    return String(value || "").replace(/([.,]00)(?=[^0-9]*$)/, "");
  }

  function refreshCartBadge() {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        if (!data) return;
        document.querySelectorAll("[data-cart-count]").forEach(function (node) {
          node.textContent = data.item_count > 0 ? String(data.item_count) : "";
        });
      })
      .catch(function () {
        /* local preview or unauthenticated theme editor */
      });
  }

  function bindReveal() {
    var nodes = document.querySelectorAll(".reveal");
    if (!nodes.length) return;

    if (window.Shopify && window.Shopify.designMode) {
      nodes.forEach(function (node) { node.classList.add("is-visible"); });
      return;
    }

    if (!("IntersectionObserver" in window)) {
      nodes.forEach(function (node) { node.classList.add("is-visible"); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    nodes.forEach(function (node) {
      if (node.classList.contains("is-visible")) return;
      observer.observe(node);
    });
  }

  function bindProductDetailForms() {
    document.querySelectorAll(".js-product-detail-form").forEach(function (form) {
      if (form.getAttribute("data-product-form-bound") === "true") return;
      form.setAttribute("data-product-form-bound", "true");
      var root = form.closest("[data-product-detail-root]");
      if (!root) return;

      var currencyCode = root.getAttribute("data-currency-code") || "USD";
      var compareNode = root.querySelector("[data-product-price-compare]");
      var discountNode = root.querySelector("[data-product-price-discount]");
      var actualNode = root.querySelector("[data-product-price-actual]");
      var heroImage = root.querySelector("[data-product-hero-image]");
      var variantOptions = form.querySelectorAll("[data-product-variant-option]");

      if (!variantOptions.length) return;

      function syncVariantState(input) {
        if (!input) return;

        var price = parseInt(input.getAttribute("data-variant-price") || "0", 10);
        var compare = parseInt(input.getAttribute("data-variant-compare") || "0", 10);
        var hasCompare = Number.isFinite(compare) && Number.isFinite(price) && compare > price && compare > 0;

        if (actualNode && Number.isFinite(price)) {
          actualNode.textContent = stripMoneyDecimals(formatCents(price, currencyCode));
        }

        if (compareNode) {
          if (hasCompare) {
            compareNode.hidden = false;
            compareNode.textContent = stripMoneyDecimals(formatCents(compare, currencyCode));
          } else {
            compareNode.hidden = true;
            compareNode.textContent = "";
          }
        }

        if (discountNode) {
          if (hasCompare) {
            var discount = Math.round(((compare - price) * 100) / compare);
            discountNode.hidden = false;
            discountNode.textContent = "-" + discount + "%";
          } else {
            discountNode.hidden = true;
            discountNode.textContent = "";
          }
        }

        var nextImageSrc = input.getAttribute("data-variant-image-src");
        if (heroImage && nextImageSrc) {
          heroImage.src = nextImageSrc;
          var nextAlt = input.getAttribute("data-variant-image-alt");
          if (nextAlt) {
            heroImage.alt = nextAlt;
          }
        }
      }

      variantOptions.forEach(function (input) {
        input.addEventListener("change", function () {
          syncVariantState(input);
        });
      });

      var initialInput = form.querySelector("[data-product-variant-option]:checked") || variantOptions[0];
      if (initialInput) {
        syncVariantState(initialInput);
      }
    });
  }

  function bindProductMediaGallery() {
    document.querySelectorAll("[data-product-detail-root]").forEach(function (root) {
      if (root.getAttribute("data-product-gallery-bound") === "true") return;
      root.setAttribute("data-product-gallery-bound", "true");
      var heroImage = root.querySelector("[data-product-hero-image]");
      var detailImage = root.querySelector("[data-product-detail-image]");
      var triggers = root.querySelectorAll("[data-product-gallery-trigger]");

      if (!triggers.length) return;

      function syncActiveState(activeTrigger) {
        triggers.forEach(function (trigger) {
          var isActive = trigger === activeTrigger;
          trigger.classList.toggle("is-active", isActive);
          trigger.setAttribute("aria-pressed", isActive ? "true" : "false");
        });
      }

      triggers.forEach(function (trigger, index) {
        if (!trigger.hasAttribute("aria-pressed")) {
          trigger.setAttribute("aria-pressed", index === 0 ? "true" : "false");
        }

        trigger.addEventListener("click", function () {
          var targetKey = trigger.getAttribute("data-gallery-target");
          var nextSrc = trigger.getAttribute("data-gallery-image-src");
          var nextAlt = trigger.getAttribute("data-gallery-image-alt") || "";
          var targetNode = targetKey === "detail" ? detailImage : heroImage;

          if (!targetNode || !nextSrc) return;

          targetNode.src = nextSrc;
          if (nextAlt) {
            targetNode.alt = nextAlt;
          }

          syncActiveState(trigger);
        });
      });
    });
  }

  function bindHeader() {
    var header = document.querySelector("[data-site-header]");
    if (!header) return;
    if (header.getAttribute("data-header-bound") === "true") return;
    header.setAttribute("data-header-bound", "true");
    body.classList.add("has-site-header");

    function syncHeaderHeight() {
      var navInner = header.querySelector(".global-nav__inner");
      var measuredHeight = navInner ? navInner.getBoundingClientRect().height : header.offsetHeight;
      var configuredHeight = parseInt(getComputedStyle(header).getPropertyValue("--header-height"), 10) || 60;
      var height = Math.round(Math.max(measuredHeight || 0, configuredHeight));
      height = Math.max(52, Math.min(height, 96));
      document.documentElement.style.setProperty("--nav-height", height + "px");
    }

    syncHeaderHeight();
    window.addEventListener("resize", syncHeaderHeight);

    var megaNav = header.querySelector("[data-mega-nav]");
    var menuButtons = header.querySelectorAll("[data-nav-menu]");
    var panels = header.querySelectorAll("[data-menu-panel]");
    var drawer = document.querySelector("[data-drawer]");
    var drawerToggle = header.querySelector("[data-drawer-toggle]");
    var drawerClose = document.querySelector("[data-drawer-close]");
    var drawerAccordions = drawer ? drawer.querySelectorAll("[data-drawer-accordion]") : [];
    var pageLinks = header.querySelectorAll("[data-nav-page]");

    var activeMenu = "";

    function syncPageState(pageKey) {
      var nextPageKey = pageKey || "";
      header.setAttribute("data-header-active", nextPageKey);
      pageLinks.forEach(function (link) {
        var isActive = nextPageKey !== "" && link.getAttribute("data-nav-page") === nextPageKey;
        link.classList.toggle("is-active", isActive);
        if (isActive) {
          link.setAttribute("aria-current", "page");
        } else {
          link.removeAttribute("aria-current");
        }
      });
    }

    function getHashPageState() {
      if (!window.location.hash) return "";
      try {
        var hashTarget = document.querySelector(window.location.hash);
        if (!hashTarget) return "";
        var keyedTarget = hashTarget.matches("[data-page-key]") ? hashTarget : hashTarget.closest("[data-page-key]");
        return keyedTarget ? keyedTarget.getAttribute("data-page-key") || "" : "";
      } catch (error) {
        return "";
      }
    }

    function detectPageState() {
      var hashPage = getHashPageState();
      if (hashPage) return hashPage;
      try {
        var params = new URLSearchParams(window.location.search || "");
        var partsGroup = (params.get("parts_group") || "").toLowerCase();
        if (partsGroup === "fast-charger" || partsGroup === "fast charger") {
          return "Fast Charger";
        }
      } catch (error) {
        /* no-op */
      }
      var pageTarget = document.querySelector("[data-page-kind]");
      if (pageTarget) {
        var pageKind = pageTarget.getAttribute("data-page-kind") || "";
        if (pageKind === "Home" || pageKind === "EUC" || pageKind === "Motorcycle" || pageKind === "Parts" || pageKind === "Fast Charger" || pageKind === "About") {
          return pageKind;
        }
        return null;
      }
      if (body.classList.contains("template-index") || document.querySelector(".campaign-screen--hero")) {
        return "Home";
      }
      if (document.querySelector('.catalog-page-shell--fast-charger, .parts-story[data-page-kind="Fast Charger"]')) {
        return "Fast Charger";
      }
      if (document.querySelector(".catalog-page-shell--motorcycle")) {
        return "Motorcycle";
      }
      if (document.querySelector(".catalog-page-shell--parts, .parts-story")) {
        return "Parts";
      }
      if (document.querySelector(".catalog-page-shell--euc, .product-story")) {
        return "EUC";
      }
      return null;
    }

    function syncMenuState() {
      menuButtons.forEach(function (button) {
        var isActive = button.getAttribute("data-nav-menu") === activeMenu;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-expanded", isActive ? "true" : "false");
      });

      panels.forEach(function (panel) {
        var shouldShow = panel.getAttribute("data-menu-panel") === activeMenu;
        panel.hidden = !shouldShow;
      });

      header.classList.toggle("is-open", Boolean(activeMenu));
      if (megaNav) {
        megaNav.setAttribute("aria-hidden", activeMenu ? "false" : "true");
      }
    }

    function closeMenu() {
      activeMenu = "";
      syncMenuState();
    }

    function openMenu(menuKey) {
      activeMenu = menuKey;
      syncMenuState();
    }

    syncPageState(header.getAttribute("data-header-active") || "");

    var forcedPage = detectPageState();
    if (forcedPage !== null) {
      syncPageState(forcedPage);
    }

    window.addEventListener("hashchange", function () {
      var detectedPage = detectPageState();
      if (detectedPage !== null) {
        syncPageState(detectedPage);
      } else {
        syncPageState(header.getAttribute("data-header-active") || "");
      }
    });

    pageLinks.forEach(function (link) {
      link.addEventListener("click", function () {
        syncPageState(link.getAttribute("data-nav-page") || "");
      });
    });

    menuButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var menuKey = button.getAttribute("data-nav-menu");
        if (!menuKey) return;
        if (activeMenu === menuKey) {
          closeMenu();
        } else {
          openMenu(menuKey);
        }
      });
    });

    document.addEventListener("click", function (event) {
      if (!header.contains(event.target)) {
        closeMenu();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeMenu();
        if (drawer) {
          drawer.classList.remove("is-open");
          drawer.setAttribute("aria-hidden", "true");
        }
      }
    });

    if (drawer && drawerToggle) {
      drawerToggle.addEventListener("click", function () {
        closeMenu();
        var willOpen = !drawer.classList.contains("is-open");
        drawer.classList.toggle("is-open", willOpen);
        drawer.setAttribute("aria-hidden", willOpen ? "false" : "true");
        drawerToggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
        body.style.overflow = willOpen ? "hidden" : "";
      });
    }

    if (drawer && drawerClose) {
      drawerClose.addEventListener("click", function () {
        drawer.classList.remove("is-open");
        drawer.setAttribute("aria-hidden", "true");
        if (drawerToggle) drawerToggle.setAttribute("aria-expanded", "false");
        body.style.overflow = "";
      });
    }

    if (drawer) {
      drawer.addEventListener("click", function (event) {
        if (event.target === drawer) {
          drawer.classList.remove("is-open");
          drawer.setAttribute("aria-hidden", "true");
          if (drawerToggle) drawerToggle.setAttribute("aria-expanded", "false");
          body.style.overflow = "";
        }
      });
    }

    drawerAccordions.forEach(function (button) {
      var panelId = button.getAttribute("aria-controls");
      if (!panelId) return;
      var panel = drawer.querySelector("#" + panelId);
      if (!panel) return;

      panel.hidden = button.getAttribute("aria-expanded") !== "true";

      button.addEventListener("click", function () {
        var willOpen = button.getAttribute("aria-expanded") !== "true";
        drawerAccordions.forEach(function (otherButton) {
          var otherPanelId = otherButton.getAttribute("aria-controls");
          var otherPanel = otherPanelId ? drawer.querySelector("#" + otherPanelId) : null;
          var isCurrent = otherButton === button;
          otherButton.setAttribute("aria-expanded", isCurrent && willOpen ? "true" : "false");
          if (otherPanel) {
            otherPanel.hidden = !(isCurrent && willOpen);
          }
        });
      });
    });

    header.querySelectorAll("[data-carousel]").forEach(function (carousel) {
      var track = carousel.querySelector("[data-carousel-track]");
      var prev = carousel.querySelector("[data-carousel-prev]");
      var next = carousel.querySelector("[data-carousel-next]");
      if (!track || !prev || !next) return;

      function step() {
        var firstCard = track.querySelector(".mega-nav__product");
        var gap = parseFloat(getComputedStyle(track).gap || "16") || 16;
        return firstCard ? firstCard.getBoundingClientRect().width + gap : track.clientWidth * 0.75;
      }

      function syncButtons() {
        var maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= maxScroll - 4;
      }

      prev.addEventListener("click", function () {
        track.scrollBy({ left: step() * -1, behavior: "smooth" });
      });

      next.addEventListener("click", function () {
        track.scrollBy({ left: step(), behavior: "smooth" });
      });

      track.addEventListener("scroll", syncButtons, { passive: true });
      window.addEventListener("resize", syncButtons);
      syncButtons();
    });
  }

  function bindQuickView() {
    var modal = document.querySelector("[data-qv-modal]");
    if (!modal) return;

    var imageNode = modal.querySelector("[data-qv-image]");
    var thumbsNode = modal.querySelector("[data-qv-thumbs]");
    var metaNode = modal.querySelector("[data-qv-meta]");
    var titleNode = modal.querySelector("[data-qv-title]");
    var priceNode = modal.querySelector("[data-qv-price]");
    var summaryNode = modal.querySelector("[data-qv-summary]");
    var purchaseNode = modal.querySelector("[data-qv-purchase]");
    var purchaseHint = modal.querySelector("[data-qv-purchase-hint]");
    var variantNode = modal.querySelector("[data-qv-variant-id]");
    var qtyInput = modal.querySelector("[data-qv-qty-input]");
    var qtyForm = modal.querySelector("[data-qv-qty-form]");
    var qtyMinus = modal.querySelector("[data-qv-qty-minus]");
    var qtyPlus = modal.querySelector("[data-qv-qty-plus]");
    var addCartBtn = modal.querySelector("[data-qv-add-cart]");
    var buyNowBtn = modal.querySelector("[data-qv-buy-now]");
    var linkNode = modal.querySelector("[data-qv-link]");
    var dismissButtons = modal.querySelectorAll("[data-qv-close], [data-qv-dismiss]");
    var featuresNode = modal.querySelector("[data-qv-features]");
    var fullTitleNode = modal.querySelector("[data-qv-full-title]");
    var fullDetailsNode = modal.querySelector("[data-qv-full-details]");
    var formNode = modal.querySelector("[data-qv-cart-form]");

    var currentData = null;
    var currentImages = [];
    var modalCopy = {
      defaultLinkLabel: modal.dataset.qvDefaultLinkLabel || "Official Product Page",
      productFullTitle: modal.dataset.qvProductFullTitle || "Accessory Full Details",
      infoFullTitle: modal.dataset.qvInfoFullTitle || "Full Details",
      hintProductReady: modal.dataset.qvHintProductReady || "Add to cart and Buy Now are ready in Quick View.",
      hintInfoOnly: modal.dataset.qvHintInfoOnly || "This card is informational. Purchase is not available in Quick View.",
      hintAdding: modal.dataset.qvHintAdding || "Adding to cart...",
      hintAdded: modal.dataset.qvHintAdded || "Added to cart.",
      hintFailed: modal.dataset.qvHintFailed || "Unable to add to cart in this preview context."
    };

    function renderThumbnails(images) {
      if (!thumbsNode) return;
      thumbsNode.innerHTML = "";
      currentImages = images || [];

      currentImages.forEach(function (imageUrl, index) {
        if (!imageUrl) return;
        var button = document.createElement("button");
        button.type = "button";
        button.className = "modal-thumb" + (index === 0 ? " is-active" : "");
        button.dataset.index = String(index);

        var image = document.createElement("img");
        image.src = imageUrl;
        image.alt = currentData && currentData.title ? currentData.title : "Preview";
        button.appendChild(image);
        thumbsNode.appendChild(button);
      });
    }

    function setHeroImage(imageUrl) {
      if (!imageNode) return;
      imageNode.src = imageUrl || "";
      imageNode.alt = currentData && currentData.title ? currentData.title : "";
    }

    function buildMetaPills(data) {
      if (!metaNode) return;
      metaNode.innerHTML = "";
      [data.vendor, data.type, data.status, data.handle].forEach(function (value) {
        if (!value) return;
        var span = document.createElement("span");
        span.className = "modal-pill";
        span.textContent = value;
        metaNode.appendChild(span);
      });
    }

    function buildFeatures(items) {
      if (!featuresNode) return;
      featuresNode.innerHTML = "";
      var normalized = Array.isArray(items) ? items.filter(Boolean) : [];
      featuresNode.hidden = normalized.length === 0;
      normalized.forEach(function (item) {
        var li = document.createElement("li");
        li.textContent = item;
        featuresNode.appendChild(li);
      });
    }

    function syncQty() {
      var qty = sanitizeQty(qtyInput.value);
      qtyInput.value = String(qty);
      if (qtyForm) qtyForm.value = String(qty);
      return qty;
    }

    function openModal(trigger) {
      var dataNode = trigger.querySelector(".qv-data");
      var fullNode = trigger.querySelector(".qv-full-details");
      var data = parseJsonScript(dataNode);
      if (!data) return;

      currentData = data;
      var typeNormalized = String(data.type || "").toLowerCase();
      var isSupportImageOnly = data.mode !== "product" && typeNormalized === "support";
      modal.classList.toggle("is-support-image-only", isSupportImageOnly);

      titleNode.textContent = data.title || "";
      summaryNode.textContent = data.summary || "";
      priceNode.textContent = data.priceText || "";
      priceNode.hidden = !data.priceText;
      summaryNode.hidden = !data.summary;

      buildMetaPills(data);
      buildFeatures(data.features);

      fullTitleNode.textContent = data.mode === "product" ? modalCopy.productFullTitle : (data.type || modalCopy.infoFullTitle);
      fullDetailsNode.innerHTML = fullNode ? fullNode.innerHTML : "";

      var images = Array.isArray(data.images) && data.images.length ? data.images : [data.image].filter(Boolean);
      renderThumbnails(images);
      setHeroImage(images[0] || data.image || "");

      qtyInput.value = "1";
      syncQty();

      var isProduct = data.mode === "product";
      purchaseNode.hidden = !isProduct;
      if (variantNode) {
        variantNode.value = data.variantId || "";
      }

      if (purchaseHint) {
        purchaseHint.textContent = isProduct
          ? modalCopy.hintProductReady
          : modalCopy.hintInfoOnly;
      }

      linkNode.hidden = !data.productUrl;
      if (data.productUrl) {
        linkNode.href = data.productUrl;
        linkNode.textContent = data.linkLabel || modalCopy.defaultLinkLabel;
      }

      if (buyNowBtn) {
        if (isProduct && data.variantId) {
          buyNowBtn.hidden = false;
        } else {
          buyNowBtn.hidden = true;
        }
      }

      modal.hidden = false;
      modal.classList.add("is-open");
      body.style.overflow = "hidden";
    }

    function closeModal() {
      modal.hidden = true;
      modal.classList.remove("is-open");
      modal.classList.remove("is-support-image-only");
      body.style.overflow = "";
    }

    document.addEventListener("click", function (event) {
      var trigger = event.target.closest("[data-qv-trigger]");
      if (trigger) {
        event.preventDefault();
        openModal(trigger);
        return;
      }

      var thumb = event.target.closest(".modal-thumb");
      if (thumb) {
        var index = parseInt(thumb.dataset.index || "0", 10);
        setHeroImage(currentImages[index] || currentImages[0] || "");
        thumbsNode.querySelectorAll(".modal-thumb").forEach(function (node, thumbIndex) {
          node.classList.toggle("is-active", thumbIndex === index);
        });
      }
    });

    dismissButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        closeModal();
      });
    });

    modal.addEventListener("click", function (event) {
      if (event.target === modal) closeModal();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && modal.classList.contains("is-open")) {
        closeModal();
      }
    });

    qtyMinus.addEventListener("click", function () {
      qtyInput.value = String(Math.max(1, sanitizeQty(qtyInput.value) - 1));
      syncQty();
    });

    qtyPlus.addEventListener("click", function () {
      qtyInput.value = String(Math.min(99, sanitizeQty(qtyInput.value) + 1));
      syncQty();
    });

    qtyInput.addEventListener("input", syncQty);
    qtyInput.addEventListener("change", syncQty);

    if (formNode) {
      formNode.addEventListener("submit", function (event) {
        event.preventDefault();
        if (!currentData || !currentData.variantId) return;

        var qty = syncQty();
        addCartBtn.disabled = true;
        if (purchaseHint) purchaseHint.textContent = modalCopy.hintAdding;

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          credentials: "same-origin",
          body: JSON.stringify({
            id: currentData.variantId,
            quantity: qty
          })
        })
          .then(function (response) {
            return response.ok ? response.json() : Promise.reject(new Error("Failed to add to cart"));
          })
          .then(function () {
            if (purchaseHint) purchaseHint.textContent = modalCopy.hintAdded;
            refreshCartBadge();
          })
          .catch(function () {
            if (purchaseHint) purchaseHint.textContent = modalCopy.hintFailed;
          })
          .finally(function () {
            addCartBtn.disabled = false;
          });
      });
    }

    if (buyNowBtn) {
      buyNowBtn.addEventListener("click", function (event) {
        event.preventDefault();
        if (!currentData) return;
        if (currentData.variantId) {
          var qty = syncQty();
          escapeTopNavigation("/cart/" + currentData.variantId + ":" + qty);
          return;
        }
        if (currentData.productUrl) {
          escapeTopNavigation(currentData.productUrl);
        }
      });
    }

    if (linkNode) {
      linkNode.addEventListener("click", function (event) {
        if (linkNode.hidden || !linkNode.href) {
          event.preventDefault();
          return;
        }
        closeModal();
      });
    }
  }

  function bindCatalogCardAddToCart() {
    var forms = document.querySelectorAll(".catalog-card__purchase-form");
    if (!forms.length) return;

    forms.forEach(function (form) {
      if (form.getAttribute("data-catalog-cart-bound") === "true") return;
      form.setAttribute("data-catalog-cart-bound", "true");
      var addButton = form.querySelector('button.btn--primary[type="submit"]');
      if (!addButton) return;

      addButton.addEventListener("click", function (event) {
        event.preventDefault();
        var idInput = form.querySelector('input[name="id"]');
        if (!idInput || !idInput.value) return;

        addButton.disabled = true;

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          credentials: "same-origin",
          body: JSON.stringify({
            id: idInput.value,
            quantity: 1
          })
        })
          .then(function (response) {
            return response.ok ? response.json() : Promise.reject(new Error("Unable to add product"));
          })
          .then(function () {
            refreshCartBadge();
          })
          .catch(function () {
            /* keep page stable in preview contexts */
          })
          .finally(function () {
            addButton.disabled = false;
          });
      });
    });
  }

  function bindCatalogGroups() {
    var groups = document.querySelectorAll("[data-catalog-group]");
    if (!groups.length) return;
    var partsGroupFilter = "";

    function normalizePartsGroup(value) {
      return String(value || "")
        .trim()
        .toLowerCase()
        .replace(/&amp;/g, "&")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    }

    try {
      var params = new URLSearchParams(window.location.search || "");
      partsGroupFilter = normalizePartsGroup(params.get("parts_group") || "");
    } catch (error) {
      partsGroupFilter = "";
    }

    function applyPartsGroupFilter() {
      var shell = document.querySelector(".catalog-page-shell");
      if (!partsGroupFilter) {
        if (shell) shell.classList.remove("is-filtering-parts-group");
        return;
      }

      var matchedGroup = null;
      groups.forEach(function (group) {
        var groupKey = normalizePartsGroup(group.getAttribute("data-part-group") || group.id.replace(/^parts-/, ""));
        if (!groupKey) return;

        var isMatch = groupKey === partsGroupFilter;
        group.hidden = !isMatch;
        group.classList.toggle("catalog-group--filtered-out", !isMatch);
        if (isMatch) {
          matchedGroup = group;
          group.classList.add("is-expanded");
        }
      });

      if (!matchedGroup) {
        if (shell) shell.classList.remove("is-filtering-parts-group");
        return;
      }

      shell = matchedGroup.closest(".catalog-page-shell");
      var groupLabel = matchedGroup.getAttribute("data-part-group-label") || "";
      if (shell && groupLabel) {
        shell.setAttribute("data-page-kind", partsGroupFilter === "fast-charger" ? "Fast Charger" : "Parts");
        var heading = shell.querySelector(".catalog-grid-head h2");
        if (heading) heading.textContent = groupLabel;
      }

      var groupHead = matchedGroup.querySelector(".catalog-group__head");
      var groupsContainer = matchedGroup.closest(".catalog-groups");
      if (!groupHead || !groupsContainer || groupHead.querySelector(".catalog-group__all-link")) {
        if (shell) shell.classList.remove("is-filtering-parts-group");
        return;
      }

      var allUrl = groupsContainer.getAttribute("data-parts-all-url") || "/collections/types?q=Parts";
      var allLabel = groupsContainer.getAttribute("data-parts-all-label") || "All Parts";
      var allLink = document.createElement("a");
      allLink.className = "catalog-group__all-link";
      allLink.href = allUrl;
      allLink.setAttribute("data-open-top", "");
      allLink.textContent = allLabel;
      groupHead.appendChild(allLink);

      if (shell) shell.classList.remove("is-filtering-parts-group");
    }

    function syncGroup(group) {
      var items = Array.prototype.slice.call(group.querySelectorAll("[data-catalog-item]"));
      var moreButton = group.querySelector("[data-catalog-more]");
      if (!items.length) {
        if (moreButton) moreButton.hidden = true;
        return;
      }

      var desktopLimit = parseInt(group.getAttribute("data-group-limit-desktop") || "50", 10);
      var mobileLimit = parseInt(group.getAttribute("data-group-limit-mobile") || "30", 10);
      var limit = window.matchMedia("(max-width: 989px)").matches ? mobileLimit : desktopLimit;
      var expanded = group.classList.contains("is-expanded");

      items.forEach(function (item, index) {
        item.classList.toggle("catalog-item--hidden", !expanded && index >= limit);
      });

      if (moreButton) {
        moreButton.hidden = items.length <= limit;
        moreButton.textContent = expanded
          ? moreButton.getAttribute("data-label-collapse") || "Collapse"
          : moreButton.getAttribute("data-label-more") || "More";
      }
    }

    applyPartsGroupFilter();

    groups.forEach(function (group) {
      syncGroup(group);
      var moreButton = group.querySelector("[data-catalog-more]");
      if (!moreButton) return;
      if (moreButton.getAttribute("data-catalog-more-bound") === "true") return;
      moreButton.setAttribute("data-catalog-more-bound", "true");
      moreButton.addEventListener("click", function () {
        group.classList.toggle("is-expanded");
        syncGroup(group);
      });
    });

    window.addEventListener("resize", function () {
      groups.forEach(syncGroup);
    });
  }

  function bindFloatingChatFallback() {
    var fallback = document.querySelector("[data-chat-fallback]");
    if (!fallback) return;

    var hideFallback = function () {
      var nativeChat = document.querySelector('iframe[src*="shopify"], iframe[src*="chat"], #ShopifyChat, [data-shopify-chat]');
      if (nativeChat) {
        fallback.style.display = "none";
      }
    };

    hideFallback();
    window.setTimeout(hideFallback, 1500);
  }

  function bindUtilityModal() {
    var modal = document.querySelector("[data-utility-modal]");
    if (!modal) return;

    var closeButton = modal.querySelector("[data-utility-close]");
    var views = modal.querySelectorAll("[data-utility-view]");
    var cartList = modal.querySelector("[data-utility-cart-list]");
    var cartSubtotal = modal.querySelector("[data-utility-cart-subtotal]");
    var searchForm = modal.querySelector("[data-utility-search-form]");
    var searchResults = modal.querySelector("[data-utility-search-results]");

    function renderSearchResults(products, query) {
      if (!searchResults) return;

      if (!products || !products.length) {
        searchResults.innerHTML = '<div class="utility-search-results__empty">' + i18n("search_no_result", 'No result for "{{query}}".').replace("{{query}}", query) + "</div>";
        return;
      }

      var html = products.map(function (product) {
        var image = product.image ? '<img src="' + product.image + '" alt="' + (product.title || i18n("search_untitled", "Untitled")) + '">' : '<div class="utility-search-results__no-image">' + i18n("search_no_image", "No image") + "</div>";
        return [
          '<a class="utility-search-results__item" href="' + (product.url || "#") + '" data-open-top>',
          '<div class="utility-search-results__media">',
          image,
          "</div>",
          '<div class="utility-search-results__copy">',
          '<div class="utility-search-results__title">' + (product.title || i18n("search_untitled", "Untitled")) + "</div>",
          '<div class="utility-search-results__meta">' + (product.vendor || i18n("search_vendor_fallback", "EUCshop")) + "</div>",
          "</div>",
          "</a>"
        ].join("");
      }).join("");

      searchResults.innerHTML = html;
    }

    function setView(viewKey) {
      views.forEach(function (viewNode) {
        viewNode.hidden = viewNode.getAttribute("data-utility-view") !== viewKey;
      });
    }

    function renderCart() {
      if (!cartList) return;
      cartList.innerHTML = i18n("cart_loading", "Loading cart...");
      fetch("/cart.js", { credentials: "same-origin" })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) {
          if (!cart) throw new Error("Unable to read cart");
          if (!cart.items || !cart.items.length) {
            cartList.innerHTML = '<p class="utility-cart__price">' + i18n("cart_empty", "Your cart is empty.") + "</p>";
            if (cartSubtotal) {
              cartSubtotal.textContent = i18n("cart_subtotal", "Subtotal: {{amount}}").replace("{{amount}}", formatCents(0, cart.currency));
            }
            return;
          }

          var html = cart.items.map(function (item) {
            var image = item.image ? '<img src="' + item.image + '" alt="' + (item.product_title || i18n("cart_item_fallback", "Item")) + '">' : '<div class="utility-cart__placeholder"></div>';
            return [
              '<div class="utility-cart__item">',
              image,
              '<div>',
              '<div class="utility-cart__name">' + (item.product_title || i18n("cart_item_fallback", "Item")) + '</div>',
              '<div class="utility-cart__qty-controls">',
              '<button type="button" class="utility-cart__qty-btn" data-cart-change data-cart-key="' + item.key + '" data-cart-qty="' + Math.max(0, item.quantity - 1) + '">-</button>',
              '<span class="utility-cart__qty-value">' + item.quantity + "</span>",
              '<button type="button" class="utility-cart__qty-btn" data-cart-change data-cart-key="' + item.key + '" data-cart-qty="' + (item.quantity + 1) + '">+</button>',
              '<button type="button" class="utility-cart__remove" data-cart-change data-cart-key="' + item.key + '" data-cart-qty="0">' + i18n("cart_delete", "Delete") + "</button>",
              "</div>",
              "</div>",
              '<div class="utility-cart__price">' + formatCents(item.final_line_price || 0, cart.currency) + "</div>",
              "</div>"
            ].join("");
          }).join("");
          cartList.innerHTML = html;
          if (cartSubtotal) {
            cartSubtotal.textContent = i18n("cart_subtotal", "Subtotal: {{amount}}").replace("{{amount}}", formatCents(cart.total_price || 0, cart.currency));
          }
          refreshCartBadge();
        })
        .catch(function () {
          cartList.innerHTML = '<p class="utility-cart__price">' + i18n("cart_unavailable", "Unable to load cart in this preview context.") + "</p>";
          if (cartSubtotal) {
            cartSubtotal.textContent = "";
          }
        });
    }

    function openModal(viewKey) {
      setView(viewKey);
      if (viewKey === "cart") {
        renderCart();
      }
      if (viewKey === "search" && searchResults) {
        searchResults.innerHTML = '<div class="utility-search-results__empty">' + i18n("search_prompt", "Search products and parts in this window.") + "</div>";
      }
      modal.hidden = false;
      body.style.overflow = "hidden";
    }

    function closeModal() {
      modal.hidden = true;
      body.style.overflow = "";
    }

    document.addEventListener("click", function (event) {
      var trigger = event.target.closest("[data-utility-open]");
      if (trigger) {
        event.preventDefault();
        var viewKey = trigger.getAttribute("data-utility-open");
        openModal(viewKey || "search");
        return;
      }

      if (closeButton && event.target === closeButton) {
        closeModal();
        return;
      }

      if (event.target === modal) {
        closeModal();
        return;
      }

      var cartChangeButton = event.target.closest("[data-cart-change]");
      if (cartChangeButton) {
        event.preventDefault();
        var key = cartChangeButton.getAttribute("data-cart-key");
        var nextQty = parseInt(cartChangeButton.getAttribute("data-cart-qty") || "0", 10);
        if (!key || !Number.isFinite(nextQty)) return;
        cartChangeButton.disabled = true;

        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          credentials: "same-origin",
          body: JSON.stringify({
            id: key,
            quantity: Math.max(0, nextQty)
          })
        })
          .then(function (response) {
            return response.ok ? response.json() : Promise.reject(new Error("cart change failed"));
          })
          .then(function () {
            renderCart();
            refreshCartBadge();
          })
          .catch(function () {
            renderCart();
          })
          .finally(function () {
            cartChangeButton.disabled = false;
          });
      }
    });

    if (closeButton) {
      closeButton.addEventListener("click", closeModal);
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !modal.hidden) {
        closeModal();
      }
    });

    if (searchForm) {
      searchForm.addEventListener("submit", function (event) {
        event.preventDefault();
        var input = searchForm.querySelector('input[name="q"]');
        var query = input ? String(input.value || "").trim() : "";
        if (!query) return;
        if (searchResults) {
          searchResults.innerHTML = '<div class="utility-search-results__empty">' + i18n("search_searching", "Searching...") + "</div>";
        }

        var params = new URLSearchParams();
        params.set("q", query);
        params.set("resources[type]", "product");
        params.set("resources[limit]", "12");
        params.set("resources[options][unavailable_products]", "last");

        fetch("/search/suggest.json?" + params.toString(), {
          credentials: "same-origin",
          headers: { "Accept": "application/json" }
        })
          .then(function (response) {
            return response.ok ? response.json() : Promise.reject(new Error("search failed"));
          })
          .then(function (payload) {
            var products = payload && payload.resources && payload.resources.results && payload.resources.results.products
              ? payload.resources.results.products
              : [];
            renderSearchResults(products, query);
          })
          .catch(function () {
            if (searchResults) {
              searchResults.innerHTML = '<div class="utility-search-results__empty">' + i18n("search_unavailable", "Search is unavailable in this preview context.") + "</div>";
            }
          });
      });
    }
  }

  redirectLegacyCollectionFilters();
  bindTopNavigation();
  bindLocalizationForms();
  bindHeader();
  bindQuickView();
  bindCatalogCardAddToCart();
  bindCatalogGroups();
  bindProductDetailForms();
  bindProductMediaGallery();
  bindUtilityModal();
  bindFloatingChatFallback();
  bindReveal();
  refreshCartBadge();

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function () {
      bindHeader();
      bindCatalogCardAddToCart();
      bindCatalogGroups();
      bindProductDetailForms();
      bindProductMediaGallery();
      bindReveal();
      refreshCartBadge();
    });
    document.addEventListener("shopify:block:select", function () {
      bindCatalogGroups();
      bindReveal();
    });
  }
})();
